import { View, FlatList, StyleSheet } from "react-native";
import MessdatenItem from "./MessdatenItem";

function MessdatenList({ data, remarks, selectedId, onItemPress }) {
  return (
    <View style={styles.firmContainer}>
      <FlatList
        data={data}
        renderItem={(itemData) => {
          return (
            <MessdatenItem
              item={itemData}
              remark={remarks?.[itemData.item.id] ?? itemData.item.remark ?? ""}
              isSelected={selectedId === itemData.item.id}
              onPress={() => onItemPress && onItemPress(itemData.item)}
            />
          );
        }}
        keyExtractor={(item) => item.id}
        alwaysBounceVertical={false}
      />
    </View>
  );
}

export default MessdatenList;

const styles = StyleSheet.create({
  firmContainer: {
    flex: 5,
    paddingHorizontal: 10,
  },
});
